import * as React from 'react';
import { InputNumber as DesignInputNumber } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const InputNumber = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignInputNumber className={className} {...formItemSettings}  />
    </FormItem>
  );
};

export default InputNumber;
